import constants from 'constants'
import { getEmployeeId } from 'utils/getEmployeeId'
import { getFiscalYearTimestamps } from 'utils/fiscalYear'

export const handleFilterValueFromSession = (filterBy) => {
  const sessionKey = constants.PARTNERPLAN.SEARCHSESSIONKEY.STATE

  const defaultFilter = {
    isPlanStatusSearch: false,
    isPlanYearSearch: false,
    isTextSearch: false,
    isClearFilteredData: false,
    isInitialLoad: false,
  }

  const savedState = sessionStorage.getItem(sessionKey)
  const filterSelection = savedState ? JSON.parse(savedState) : defaultFilter

  // If no filterBy is provided, return the entire filter object
  if (!filterBy) {
    return filterSelection
  }

  const filterByLower = filterBy.toLowerCase()
  const {
    YEAR, STATUS, CLEAR, INITIAL, TEXT,
  } = constants.PARTNERPLAN.SEARCHFILTERSTATE

  if (filterByLower === STATUS.toLowerCase()) {
    return filterSelection.isPlanStatusSearch
  }
  if (filterByLower === YEAR.toLowerCase()) {
    return filterSelection.isPlanYearSearch
  }
  if (filterByLower === CLEAR.toLowerCase()) {
    return filterSelection.isClearFilteredData
  }
  if (filterByLower === TEXT.toLowerCase()) {
    return filterSelection.isTextSearch
  }
  if (filterByLower === INITIAL.toLowerCase()) {
    return filterSelection.isInitialLoad
  }

  return null // or throw new Error('Invalid filter key') if you want strictness
}

export const updateFilterSessionObject = (filterBy, filterValue, exclusive = false) => {
  const sessionKey = constants.PARTNERPLAN.SEARCHSESSIONKEY.STATE

  const defaultFilter = {
    isPlanStatusSearch: false,
    isPlanYearSearch: false,
    isTextSearch: false,
    isClearFilteredData: false,
    isInitialLoad: false,
  }

  // Try to load existing filter state
  let filterSelection = defaultFilter
  const savedState = sessionStorage.getItem(sessionKey)
  if (savedState) {
    filterSelection = JSON.parse(savedState)
  }

  const filterByLower = filterBy.toLowerCase()
  const {
    YEAR, STATUS, CLEAR, INITIAL, TEXT,
  } = constants.PARTNERPLAN.SEARCHFILTERSTATE

  // If exclusive, reset all values first
  if (exclusive) {
    filterSelection = { ...defaultFilter }
  }

  // Update the specified filter value
  if (filterByLower === YEAR.toLowerCase()) {
    filterSelection.isPlanYearSearch = filterValue
  } else if (filterByLower === STATUS.toLowerCase()) {
    filterSelection.isPlanStatusSearch = filterValue
  } else if (filterByLower === CLEAR.toLowerCase()) {
    filterSelection.isClearFilteredData = filterValue
  } else if (filterByLower === TEXT.toLowerCase()) {
    filterSelection.isTextSearch = filterValue
  } else if (filterByLower === INITIAL.toLowerCase()) {
    filterSelection.isInitialLoad = filterValue
  }

  sessionStorage.setItem(sessionKey, JSON.stringify(filterSelection))
}

export const handleClearFilteredPartnerPlans = ({ setState, props }) => {
  updateFilterSessionObject(constants.PARTNERPLAN.SEARCHFILTERSTATE.CLEAR, true, true)
  setState({ filteredPartnerPlans: [] }, () => {
    props.getPartnerPlans(
      props.planView,
      getEmployeeId(props.selectedPartner, props.currentUser),
    )
  })
}

export const handleDefaultFilteredData = (partnerPlans) => {
  const filteredinfo = [...new Set(partnerPlans.partnerPlans)]
  return filteredinfo.filter(item => String(item.year) === getFiscalYearTimestamps().current.year)
}

export const handleChangeFilteredPartnerPlans = ({ setState, partnerPlans }) => {
  setTimeout(() => {
    setState({ filteredPartnerPlans: partnerPlans })
  }, 500)
  setState({ filteredPartnerPlans: partnerPlans })
}

export const handlePlanStatusSearchTrigger = (isPlanStatusSearch) => {
  updateFilterSessionObject(constants.PARTNERPLAN.SEARCHFILTERSTATE.INITIAL, false)
  updateFilterSessionObject(constants.PARTNERPLAN.SEARCHFILTERSTATE.CLEAR, false)
  updateFilterSessionObject(constants.PARTNERPLAN.SEARCHFILTERSTATE.STATUS, isPlanStatusSearch)
}

export const handlePlanYearTrigger = (isPlanYearSearch) => {
  updateFilterSessionObject(constants.PARTNERPLAN.SEARCHFILTERSTATE.INITIAL, false)
  updateFilterSessionObject(constants.PARTNERPLAN.SEARCHFILTERSTATE.CLEAR, false)
  updateFilterSessionObject(constants.PARTNERPLAN.SEARCHFILTERSTATE.YEAR, isPlanYearSearch)
}

export const handleTextSearchTrigger = (isTextSearch) => {
  updateFilterSessionObject(constants.PARTNERPLAN.SEARCHFILTERSTATE.INITIAL, false)
  updateFilterSessionObject(constants.PARTNERPLAN.SEARCHFILTERSTATE.CLEAR, false)
  updateFilterSessionObject(constants.PARTNERPLAN.SEARCHFILTERSTATE.TEXT, isTextSearch)
}



// WEBPACK FOOTER //
// ./src/utils/partnerPlanFilter.js